import { SearchEntityKey } from '@teetsh/app/src/containers/Search/types';

export const entities: SearchEntityKey[] = [
  'seances',
  'emploisDuTemps',
  'fichesDePrep',
  'sequences',
  'programmations',
  'eleves',
  'carnets',
  'evaluations',
  'livrets',
  'reunions',
  'notes',
];
